import PassTemplatesListWrapper from './PassTemplatesListWrapper';

const PassTemplatesPage = () => {
  return <PassTemplatesListWrapper />;
};

export default PassTemplatesPage;
